import {
    TopToolbar,
    ExportButton,
    CreateButton,
    Pagination,
    ListBase,
    Title,
    ListToolbar,
    useListContext,
    SortButton,
} from 'react-admin';

import { AntennaGridList } from './AntennaGridList';
import { AntennaListFilter } from './AntennaListFilter';
import { Stack } from '@mui/material';
import { AntennaEmpty } from './AntennaEmpty';

export const AntennaList = () => {
    return (
        <ListBase
            resource="antenna"
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}
        >
            <AntennaListLayout />
        </ListBase>
    );
};

const AntennaListLayout = () => {
    const { data, isPending, filterValues } = useListContext();
    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (isPending) return null;
    if (!data?.length && !hasFilters) return <AntennaEmpty />;

    return (
        <Stack direction="row" component="div">
            <AntennaListFilter />
            <Stack sx={{ width: '100%' }}>
                <Title title={'antenna'} />
                <ListToolbar actions={<AntennaListActions />} />
                <AntennaGridList />
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const AntennaListActions = () => {
    return (
        <TopToolbar>
            <SortButton fields={['name', 'createdAt']} />
            <ExportButton />
            <CreateButton
                variant="contained"
                label="New Antenna"
                resource="antenna"
                sx={{ marginLeft: 2 }}
            />
        </TopToolbar>
    );
};
